import script from "./FeedbackClassButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeedbackClassButton.vue?vue&type=script&setup=true&lang=ts"

import "./FeedbackClassButton.vue?vue&type=style&index=0&id=721dd5a3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-721dd5a3"]])

export default __exports__